// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FormModule-base__zxBg3{display:flex;flex-direction:column;gap:var(--size-4)}.FormModule-labelAndSupportText__yqZdx{display:flex;flex-direction:column;gap:var(--size-0_5)}.FormModule-supportText__rSMm4{font:var(--font-body-400-compact);font-feature-settings:var(--feature-settings-body-400-compact);letter-spacing:var(--letter-spacing-body-400-compact)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "FormModule-base__zxBg3",
	"labelAndSupportText": "FormModule-labelAndSupportText__yqZdx",
	"supportText": "FormModule-supportText__rSMm4"
};
export default ___CSS_LOADER_EXPORT___;
